<template>
  <div>
    <v-container>
      <v-dialog v-model="modalOpen" max-width="500px">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" v-on="on">Add Banner</v-btn>
        </template>
        <v-card>
          <v-card-title>
            Add Banner
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col style="text-align: center; padding-left:50px">
                <v-progress-linear style="width:90%" v-if="progress >= 0" :value="progress"></v-progress-linear>
              </v-col>
            </v-row>
            <v-form ref="form" @submit.prevent="saveBanner">
              <v-file-input v-model="selectedFile" label="Image" accept="image/*" show-size outlined></v-file-input>

              <v-select v-model="banner.type" label="Type" outlined :items="types"></v-select>
              <v-select v-if="banner.type == 'internal'" v-model="banner.route" item-text="name" item-value="value"
                label="Route" outlined :items="routes"></v-select>
              <v-text-field v-if="banner.type == 'external'" v-model="banner.route" label="Route"
                outlined></v-text-field>
              <p>Add CTA</p>
              <v-radio-group v-model="banner.cta" row>
                <v-radio label="Yes" :value="true"></v-radio>
                <v-radio label="No" :value="false"></v-radio>
              </v-radio-group>

              <template v-if="banner.cta">
                <v-text-field v-model="banner.action_text" label="CTA Text" outlined></v-text-field>
                <v-col cols-12>
                  <v-label>CTA Text Colour</v-label>
                  <v-color-picker v-model="banner.cta_text_color" label="CTA Text Colour" outlined></v-color-picker>
                </v-col>
                <v-col cols-12>
                  <v-label>CTA Background Colour</v-label>
                  <v-color-picker v-model="banner.cta_color" label="CTA Background Colour" outlined></v-color-picker>
                </v-col>
              </template>

              <p>Compulsory Click</p>
              <v-radio-group v-model="banner.is_dismissible" row>
                <v-radio label="Yes" :value="true"></v-radio>
                <v-radio label="No" :value="false"></v-radio>
              </v-radio-group>

              <p>Banner Size</p>
              <v-radio-group v-model="banner.is_fullscreen" row @change="validateImageSize">
                <v-radio label="Full Screen" :value="true"></v-radio>
                <v-radio label="Half Screen" :value="false"></v-radio>
              </v-radio-group>

              <v-alert v-if="imageError" type="error">
                {{ imageError }}
              </v-alert>


              <v-row justify="space-between">
                <div>
                  <v-btn color="primary" @click="saveBanner" class="mr-2">Save</v-btn>
                  <v-btn color="error" @click="closeModal">Cancel</v-btn>

                </div>
                <v-btn @click="openShowcaseModal('')">Preview</v-btn>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editModalOpen" max-width="500px">

        <v-card>
          <v-card-title>
            Edit Banner
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col style="text-align: center; padding-left:50px">
                <v-progress-linear style="width:90%" v-if="progress >= 0" :value="progress"></v-progress-linear>
              </v-col>
            </v-row>
            <v-form ref="form" @submit.prevent="editUp">
              <v-file-input v-model="selectedFile" label="Image" accept="image/*" show-size outlined disabled></v-file-input>

              <v-select v-model="activeBanner.type" label="Type" outlined :items="types" disabled></v-select>
              <v-text-field v-if="activeBanner.type == 'external'" v-model="activeBanner.route" label="Route"
                outlined disabled></v-text-field>
              <v-select v-if="activeBanner.type == 'internal'" v-model="activeBanner.route" item-text="name"
                item-value="value" label="Route" outlined :items="routes" disabled></v-select>

              <p>Add CTA</p>
              <v-radio-group v-model="activeBanner.cta" row>
                <v-radio label="Yes" :value="true"></v-radio>
                <v-radio label="No" :value="false"></v-radio>
              </v-radio-group>

              <template v-if="activeBanner.cta">
                <v-text-field v-model="activeBanner.action_text" label="Action Text" outlined></v-text-field>

                <v-col cols-12>
                  <v-label>CTA Text Colour</v-label>
                  <v-color-picker v-model="activeBanner.cta_text_color" label="CTA Text Colour"
                    outlined></v-color-picker>
                </v-col>
                <v-col cols-12>
                  <v-label>CTA Background Colour</v-label>
                  <v-color-picker v-model="activeBanner.cta_color" label="CTA Background Colour"
                    outlined></v-color-picker>
                </v-col>
              </template>

              <p>Compulsory Click</p>
              <v-radio-group v-model="activeBanner.is_dismissible" row>
                <v-radio label="Yes" :value="true"></v-radio>
                <v-radio label="No" :value="false"></v-radio>
              </v-radio-group>

              <p>Banner Size</p>
              <v-radio-group v-model="activeBanner.is_fullscreen" row disabled>
                <v-radio label="Full Screen" :value="true"></v-radio>
                <v-radio label="Half Screen" :value="false"></v-radio>
              </v-radio-group>

              <v-row justify="space-between">
                <div>
                  <v-btn color="primary" @click="editBanner" class="mr-2">Save</v-btn>
                  <v-btn color="error" @click="closeEditModal">Cancel</v-btn>
                </div>
                <v-btn @click="openShowcaseModal(activeBanner)">Preview</v-btn>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>


      <v-dialog v-model="showcaseModal" height="400px" max-width="290px" style=" border-radius:23px; ">
        <v-card max-width="100%" min-height="400px" max-height="100%"
          :style="'background-image: url(' + activeBanner.image + '); background-size: cover; background-position: center; border-radius: 12px'">
          <v-card-text>
            <!-- Display other item content -->
          </v-card-text>

          <div v-if="activeBanner.action_text" style="position: absolute; bottom: 0; left: 0; right: 0; padding: 16px;">
            <p style="text-align: center;">
              <v-btn
                :style="{ backgroundColor: activeBanner.cta_color, color: activeBanner.cta_text_color, width: '100%' }">
                {{ activeBanner.action_text }}
              </v-btn>
            </p>
          </div>
        </v-card>
      </v-dialog>


      <v-data-table class="mt-5 text-capitalize" :items="banners" :headers="headers" item-key="text"
        hide-default-footer>

        <template v-slot:item.image="{ item }">
          <v-avatar size="32" color="grey">
            <img :src="item.image" />
          </v-avatar>
        </template>

        <template v-slot:item.route="{ item }">
          <a v-if="item.type === 'external'" :href="item.route" target="_blank">
            <v-row align="center">
              <p class="text-lowercase mb-0">{{ item.route }}</p>
              <v-icon size="small">
                mdi-open-in-new
              </v-icon>
            </v-row>
          </a>

          <p v-else class="text-lowercase mb-0">{{ item.route }}</p>

        </template>

        <template v-slot:item.status="{ item, index }">
          <v-row align="center">
            <p class="mb-0">{{ item.is_show ? 'Active' : 'Inactive' }}</p>
            <v-menu :close-on-content-click="true" bottom right>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon>
                  <v-icon size="medium">
                    mdi-dots-vertical
                  </v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item link v-if="!item.is_show">
                  <v-list-item-title @click="toggleShowStatus(item, index)">Activate Banner</v-list-item-title>
                </v-list-item>
                <v-list-item link v-else>
                  <v-list-item-title @click="toggleShowStatus(item, index)">Deactivate Banner</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-row>
        </template>

        <template v-slot:item.action_text="{ item }">
          <v-btn v-if="item.action_text" :style="{ backgroundColor: item.cta_color, color: item.cta_text_color }">{{
            item.action_text }}</v-btn>
        </template>


        <template v-slot:item.actions="{ item, index }">

          <td>
            <!-- <v-btn icon color="primary" @click="toggleShowDismissibility(item, index)">
              <v-icon v-if="item.is_dismissible">mdi-cancel</v-icon>
              <v-icon v-else>mdi-target</v-icon>
            </v-btn> -->
            <v-btn icon class="mr-2" color="primary" @click="openShowcaseModal(item)">
              <v-icon size="medium">mdi-panorama-variant</v-icon>
            </v-btn>
            <v-btn icon class="mr-2" color="primary" @click="openEditModal(item, index)">
              <v-icon size="medium">mdi-pencil</v-icon>
            </v-btn>
            <!-- <v-btn icon class="m-2" color="error" @click="deleteBanner(item, index)">
              <v-icon>mdi-delete</v-icon>
            </v-btn> -->
          </td>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>
<script>

import { PromoService } from "@/services";
import * as storageService from "@/utils/firebase/storage";
import app from '@/main';

export default {
  data() {
    return {
      selectedFile: null,
      editModalOpen: false,
      showcaseModal: false,
      progress: -1,
      modalOpen: false,
      types: ['internal', 'external'],
      routes:
        [
          { name: 'AIRTIME_AND_DATA', value: 'AirtimeDataStack' },
          { name: 'BILL_PAYMENT', value: 'BillPaymentStack' },
          { name: 'VIEW_USER_PROFILE', value: 'ProfileStack' },
          { name: 'TUTORIALS', value: 'TutorialsStack' },
          { name: 'NOTIFICATIONS', value: 'NotificationsStack' },
          { name: 'WALLET', value: 'WalletStack' },
          { name: 'TRADE_GIFTCARDS', value: 'GiftcardStack' },
          { name: 'TRADE_CRYPTO', value: 'CryptoStack' },
          { name: 'SETTINGS', value: 'SettingsStack' },
          { name: 'RATE_CALCULATOR', value: 'RateCalculatorStack' },
          { name: 'LEADER_BOARD', value: 'LeaderBoardStack' },
          { name: 'HOW_LEADERBOARD_WORKS', value: 'HowItWorks' },
          { name: 'TRADE_HOTTEST_GIFTCARDS', value: 'HottestGiftcardsStack' },
          { name: 'ALL_TRANSACTIONS', value: 'GiftcardTransactionsStack' },
          { name: 'WITHDRAW_FROM_WALLET', value: 'ConfirmWalletWithdrawalStack' },
          { name: 'ABOUT_DTUNES', value: 'AboutStack' },
          { name: 'DELETE_ACCOUNT', value: 'DeleteAccountStack' },
          { name: 'HELP_AND_SUPPORT', value: 'HelpAndSupportStack' },
          { name: 'REFER_AND_EARN', value: 'ReferAndEarnStack' },
          { name: 'BANK_ACCOUNTS', value: 'BankAccountStack' },
          { name: 'ADD_BANK_ACCOUNT', value: 'AddAccount' },
          { name: 'REDEEM_PROMO_CODE', value: 'PromoCodeStack' },
          { name: 'CHANGE_PIN', value: 'ChangeTrnxPinStack' },
          { name: 'CREATE_NEW_PIN', value: 'CreateTrnxPinStack' },
          { name: 'CHANGE_PASSWORD', value: 'ChangePasswordStack' },
        ]
      ,
      headers: [

        { text: "Image", value: "image" },
        { text: 'Type', value: "type" },
        { text: 'Route', value: "route" },
        { text: 'Status', value: "status" },
        { text: 'CTA', value: "action_text" },
        { text: "Actions", value: "actions", width: "230px" },
      ],
      activeBanner: {
        image: '',
        message: '',
        route: '',
        cta_color: '',
        cta_text_color: '',
        message_color: '',
        title_color: '',
        type: 'internal',
        title: '',
        action_text: '',
        is_dismissible: false,
        is_fullscreen: false,
      },
      banner: {
        image: '',
        message: '',
        route: '',
        cta: false,
        cta_color: '',
        cta_text_color: '',
        message_color: '',
        title_color: '',
        type: 'internal',
        title: '',
        action_text: '',
        is_dismissible: false,
        is_fullscreen: false,

      },
      banners: [],
      imagePreview: '',
      imageError: '',
    };
  },
  async mounted() {
    await this.retrieveBanners();
  },
  methods: {
    openModal() {
      this.modalOpen = true;
    },
    openShowcaseModal(item) {
      if (!item) {
        const reader = new FileReader()

        reader.onload = (e) => {
          this.imagePreview = e.target.result
          this.activeBanner = { ...this.banner, image: this.imagePreview };
        }
        reader.readAsDataURL(this.selectedFile)
        this.showcaseModal = true;
      }
      else {
        this.activeBanner = item;
        this.showcaseModal = true;
      }
    },
    openEditModal(item) {
      this.activeBanner = { ...item, cta: item.action_text ? true : false };
      this.editModalOpen = true;
    },

    async toggleShowStatus(item, index) {
      console.log(item, index);
      try {
        const data = await PromoService.toggleBanner({ id: item.id, is_show: !item.is_show });
        console.log('toggle banner text here ', data);
        console.log(item);
        app.$store.dispatch('toast', {
          message: 'banner toggled successfully',
          variant: 'success'
        });
        // this.banners.splice(index, 1);
        this.banners[index].is_show = !this.banners[index].is_show;
      } catch (error) {
        console.log(error);
      }

    },
    async toggleShowDismissibility(item, index) {
      try {
        const data = await PromoService.toggleBanner({ id: item.id, is_dismissible: !item.is_dismissible });
        console.log('toggle banner text here ', data);
        console.log(item);
        app.$store.dispatch('toast', {
          message: 'banner toggled successfully',
          variant: 'success'
        });
        // this.banners.splice(index, 1);
        this.banners[index].is_dismissible = !this.banners[index].is_dismissible;
      } catch (error) {
        console.log(error);
      }

    },
    validateImageSize() {
      this.imageError = ''
      if (!this.selectedFile) {
        return;
      }
      const runValidation = () => {
        const file = this.selectedFile;
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => {
            const width = img.width;
            const height = img.height;
            if (this.banner.is_fullscreen && (width < 400 || height < 810)) {
              reject('Full screen banners must be at least 400x810 pixels.');
            } else {
              resolve();
            }
          };
          img.onerror = () => {
            reject('Invalid image file.');
          };
          img.src = URL.createObjectURL(file);
        });
      };

      runValidation()
        .then(() => {
          this.imageError = '';
        })
        .catch((error) => {
          this.imageError = error;
        });
    },
    closeModal() {
      this.modalOpen = false;
      this.resetForm();
    },
    closeEditModal() {
      this.editModalOpen = false;
      this.resetEditForm();
    },
    resetForm() {
      this.selectedFile = null;
      this.banner = {
        image: '',
        message: '',
        route: '',
        cta_color: '',
        cta_text_color: '',
        message_color: '',
        title_color: '',
        type: 'internal',
        title: '',
        action_text: '',

      };
    },
    resetEditForm() {
      this.selectedFile = null;
      this.activeBanner = {
        image: '',
        message: '',
        route: '',
        cta_color: '',
        cta_text_color: '',
        message_color: '',
        title_color: '',
        type: 'internal',
        title: '',
        action_text: '',
        is_dismissible: false,
        is_fullscreen: false,

      };

    },
    async retrieveBanners() {
      try {
        const data = await PromoService.getBanner();
        console.log('get all banner text here ', data);
        this.banners = data;
      } catch (error) {
        console.log(error);
      }
    },
    async saveBanner() {
      if (this.imageError) {
        return
      }
      try {
        this.progress = 10;
        const data = await storageService.uploadImages('tutorials', 738464, this.selectedFile);

        if (data) {
          console.log('the data here', data);
          this.progress = 80;

          console.log(this.banner);
          this.banner.image = data;

          const result = await PromoService.createBanner(this.banner);

          if (result) {
            console.log('the result', result);

            setTimeout(() => { this.progress = -1 }, 500);
            app.$store.dispatch('toast', {
              message: 'banner uploaded successfully',
              variant: 'success'
            });

            this.banners.push({ ...this.banner });

            // Close modal and reset form fields
            this.closeModal();
            await this.retrieveBanners();
          }
        }
      } catch (error) {
        console.error('An error occurred:', error);
        this.closeModal();
      }
    },
    async editBanner() {
      try {
        if (!this.activeBanner.cta) {
          this.activeBanner.action_text = '';
          this.activeBanner.cta_color = '';
          this.activeBanner.cta_text_color = '';
        }
        delete this.activeBanner.cta
        const result = await PromoService.editBanner(this.activeBanner);

        if (result) {
          app.$store.dispatch('toast', {
            message: 'banner updated successfully',
            variant: 'success'
          });

          // Close modal and reset form fields
          this.closeEditModal();
          await this.retrieveBanners();
        }

      } catch (error) {
        console.error('An error occurred:', error);
        this.closeEditModal();
      }
    }
    ,
    async deleteBanner(item, index) {
      // Remove the banner from the array
      try {
        const data = await PromoService.deleteBanner(item.id);
        console.log('delete all banner text here ', data);
        console.log(item);
        app.$store.dispatch('toast', {
          message: 'banner deleted successfully',
          variant: 'success'
        });
        this.banners.splice(index, 1);
      } catch (error) {
        console.log(error);
      }

    }
  },
  watch: {
    selectedFile() {
      console.log('changeeee')
      this.imageError = ''
      this.validateImageSize()
    }
  }
};
</script>